<template>
  <div v-show="value" ref="dialog" class="loading_dialog">
    <div class="content">
      <img
        class="loading_icon"
        src="data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABO0lEQVQ4T5WT61WDQBBG72ABpgSs
    QErADmjAsFZg7CB2gB1skgJMB2IFpgMtAQuQ8eywICfBPOYcfgA7dx7ft8JeqCNFeQRyIIu/d0CN
    8CKer3GKjF90ToVY8jdKSApPhhjo2s4qS1nz3OcNAJ2zQ0hpWcgGf9DZPY6EKoK8rHgIZwwQKzuE
    XLxVnQx1zGhtlFtanmRDJXHmT4Q78dT/Jfff1ZGhfAANwo1YdUhlTXEqeYDM8QildWGzJyzFsz0b
    4ChQXlHeRUvUWtmT5xhsGBsaA8iqW+YloSWNqRBHKC7pwJRzZjQDeJR6SvtTY4SiQcac1txlxHMj
    7MEA0Uh1cNm5SgQv9IbrAJ3DtiQsjjkxng1+2fU7+7sLPQTeSOzW2ZZHDkz5oeCK7XjhB/LFnThg
    BmZZQQ3WTC36F0l7gaPXKaFYAAAAAElFTkSuQmCC"
      />
    </div>
  </div>
</template>
<script>
import { createNamespace, isDef } from "vant/lib/utils";
import { PopupMixin } from "vant/lib/mixins/popup";
const [createComponent, bem] = createNamespace("popup");
import { setStyle } from "../../../tools/dom";
// import ProgressBar from 'progressbar.js'
export default createComponent({
  name: "ActAlertDialog",
  mixins: [PopupMixin],
  components: {},
  props: {
    callback: Function,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    lockOnScroll: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      
    };
  },
  methods: {
    handleAction(action) {
      this.$emit("input", false);
      this.$emit(action);
      this.callback && this.callback(action);
    }
  },
  mounted() {

  },
  watch: {},
  computed: {}
});
</script>


<style lang="stylus" >
  @import "../../../share/mixins.styl"

  .loading_dialog
    background white
    width 100%
    height 100%
    position fixed !important
    top 0
    left 0
    .content
      center();
    .loading_icon {
      width: 16px;
      height: 16px;
      animation: cycle 1s linear infinite;
      -webkit-animation: cycle 1s linear infinite;
    }

   
  

</style>
